// LAP-550 — Conteneur Portfolio refactoré : chaque card utilise CardShell + accent
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import InvestmentValue from './cards/InvestmentValue'
import RepartitionInvestments from './cards/RepartitionInvestments'
import UserTarget from './cards/UserTarget'
import AdviceCard from './cards/AdviceCard'
import CoachCard from './cards/CoachCard'
import PortfolioCard from './cards/PortfolioCard'
import OpportunityCard from './cards/OpportunityCard'
import { makeGetRequest } from 'utils/api'
import CardShell from '../_shared/CardShell'
import { invTheme } from '../_shared/theme'

export default function PortFolioTab() {
  const [reports, setReports] = useState([])
  useEffect(() => {
    getInvestments()
  }, [])
  const getInvestments = async () => {
    const { data } = await makeGetRequest('/api/investment/reports/', {}, true)
    setReports([...data])
  }
  return (
    <Box sx={{ flexGrow: 1, pb: 6, mt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5} lg={3.5}>
          <CardShell accent={invTheme.accents.portfolio} detailTo="/investments/portfolio/evolution">
            <InvestmentValue report={reports.find((r) => r.type === 'valeur-investment')?.data} />
          </CardShell>
        </Grid>
        <Grid item xs={12} md={7} lg={5}>
          <CardShell accent={invTheme.accents.portfolio} detailTo="/investments/portfolio/positions">
            <PortfolioCard />
          </CardShell>
        </Grid>
        <Grid item xs={12} md={5} lg={3.5}>
          <CardShell accent={invTheme.accents.advice}>
            <AdviceCard />
          </CardShell>
        </Grid>
      </Grid>
      <Grid mt={0} container spacing={2}>
        <Grid item xs={12} md={5} lg={3.5}>
          <CardShell accent={invTheme.accents.repartition} detailTo="/investments/portfolio/repartition">
            <RepartitionInvestments
              report={reports.find((r) => r.type === 'breakdown-investment')?.data}
            />
          </CardShell>
        </Grid>
        <Grid item xs={12} md={7} lg={5}>
          <CardShell accent={invTheme.accents.opportunity} detailTo="/investments/portfolio/opportunities">
            <OpportunityCard />
          </CardShell>
        </Grid>
        <Grid item xs={12} md={5} lg={3.5}>
          <CardShell accent={invTheme.accents.target}>
            <UserTarget report={reports.find((r) => r.type === 'user-target')?.data} />
          </CardShell>
        </Grid>
      </Grid>
      {/* Coach Portefeuille — brief quantitatif quotidien (lecture seule) */}
      <Grid mt={0} container spacing={2}>
        <Grid item xs={12} md={7} lg={5}>
          <CardShell accent={invTheme.accents.market} detailTo="/investments/coach">
            <CoachCard />
          </CardShell>
        </Grid>
      </Grid>
    </Box>
  )
}
